import React from 'react';
import { Card, CardHeader, CardContent, Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import Icon, { IconProps } from './shared/Icon';

type DashboardCardProps = {
    title: string;
    icon?: IconProps['name'];
    children: React.ReactNode;
    headerRight?: React.ReactNode;
};

export const DashboardCard: React.FC<DashboardCardProps> = ({ title, icon, children, headerRight }) => {
    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <CardHeader
                title={
                    <Box display="flex" alignItems="center" gap={1}>
                        {icon && <Icon name={icon} />}
                        <Typography variant="h6" fontWeight="bold">
                            {title}
                        </Typography>
                    </Box>
                }
                action={headerRight}
            />
            <CardContent sx={{ flexGrow: 1 }}>
                <div className="fx-c fx-w fx-justify-c h-100 w-100 m-auto">{children}</div>
            </CardContent>
        </Card>
    );
};

export default DashboardCard;
